:host {
  display: block;

  av-asset {
    width: 100%;
  }

  iframe {
    width: 100%;
    height: 100%;
    border: 0;
  }

  .frame-cover {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }

  .av-card-frame {
    &.av-card-frame-center:not(.av-card-frame-fullscreen) {
      .av-card.av-card-open.av-card-blur.av-card-center {
        transform: translateX(50%) scale(0.8);
        &:hover {
          transform: translateX(50%) scale(0.85);
        }
      }
    }

    &.av-card-frame-expanded .av-card {
      width: var(--av-card-video-width-expanded);
      height: var(--av-card-video-height-expanded);
    }

    &.av-card-frame-fullscreen {
      .av-card,
      .av-card.av-card-blur,
      .av-card.av-card-blur:hover {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        border: 0;
        border-radius: 0;
        transform: none;
        // &.av-card-blur {
        //   border-radius: var(--av-border-radius-container);
        // }
      }
      // &.av-card-frame-center {
      //   .av-card.av-card-center.av-card-open.av-card-floating {
      //     left: auto;
      //     right: 50%;
      //   }
      // }
    }

    &.av-card-frame-mobile .av-card {
      border: 0px;
      position: fixed;
      left: var(--av-card-video-mobile-left);
      right: var(--av-card-video-mobile-right);
      top: var(--av-card-video-mobile-top);
      bottom: var(--av-card-video-mobile-offset);
      &.av-card-top.av-card-floating {
        top: var(--av-card-video-mobile-offset);
        bottom: var(--av-card-video-mobile-bottom);
      }
      &.av-card-center.av-card-floating {
        right: 50%;
        left: auto;
      }
    }

    &.av-card-frame-secondary {
      .av-card.av-card-bottom {
        margin-bottom: calc($container-height + 10px);
      }
    }

    &.av-card-frame-secondary {
      .av-card.av-card-top {
        margin-top: calc($container-height + 10px);
      }
    }

    .av-card {
      width: var(--av-card-video-width);
      height: var(--av-card-video-height);

      &.av-card-right.av-card-closed {
        transform: translateX(110%);
      }

      &.av-card-left.av-card-closed {
        transform: translateX(-110%);
      }
    }

    &:not(.av-card-frame-fullscreen) .av-card {
      &.av-card.av-card-right.av-card-open.av-card-blur {
        transform: translate(-40px, 0) scale(0.9);

        &:hover {
          transform: translate(-40px, 0) scale(0.92);
        }
      }
      &.av-card.av-card-left.av-card-open.av-card-blur {
        transform: translate(40px, 0) scale(0.9);

        &:hover {
          transform: translate(40px, 0) scale(0.92);
        }
      }
    }

    .av-card-body {
      padding: 0;
      height: 100%;

      > div {
        height: 100%;
      }
    }

    // border-radius: 10px;
  }

  .button-popup-open {
    position: absolute;
    background-color: black;
    width: 20px;
    height: 20px;
    padding: 4px;
    border: 0;
    cursor: pointer;
    &.button-popup-ne {
      top: 0;
      right: 0;
      border-radius: 0 0 0 4px;
    }
    &.button-popup-nw {
      top: 0;
      left: 0;
      border-radius: 0 0 4px 0;
    }
    &:focus-visible {
      outline-color: var(--av-color-focus-outline);
    }
  }
}

.info {
  height: $container-width;
  width: calc($container-width * 5);
  border-radius: calc($container-width * 0.5);
  background-color: var(--av-background-color-tray);
  position: absolute;
  padding: 10px;
  bottom: calc($container-height + 10px);
  right: 0;
  color: var(--av-color-tray);
  display: flex;
  flex-direction: row;
  align-items: center;
  box-sizing: border-box;
  &.info-left {
    right: auto;
    left: 0;
  }
  &.info-top {
    bottom: auto;
    top: calc($container-height + 10px);
  }
}

.agent-container {
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.greeting-container {
  padding-left: 10px;
}
